import NotificationController from '@/controllers/Notification/NotificationController';

const state = {
  notifications: null,
};

const getters = {
  notifications(state) {
    let notifications = state.notifications;
    if (!notifications) notifications = JSON.parse(localStorage.getItem('notifications'));
    return notifications;
  },
};

const mutations = {
  setNotifications(state, data) {
    state.notifications = data;
    localStorage.setItem('notifications', JSON.stringify(data));
  },
};

const actions = {
  async retrieveNotifications({ commit, getters }) {
    let notifications = getters.notifications;
    if (!notifications) notifications = await NotificationController.index();
    commit('setNotifications', notifications);
    return notifications;
  },
  async refreshNotifications({ commit }) {
    let notifications = await NotificationController.index();
    commit('setNotifications', notifications);
    return notifications;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
